module.exports = __webpack_public_path__ + "img/9788937832994.89544f6e.jpg";